// extracted by mini-css-extract-plugin
export default {"container":"uq-z","heading":"vq-z","text":"wq-z","info":"xq-z","link":"yq-z","fullMaxWidth":"zq-z"};